export function onServer() {
	return typeof window === 'undefined';
}

export function onClient() {
	return typeof window !== 'undefined';
}
